const Blogs = () => {
  return <></>;
};

export default Blogs;
